<app-nav-bar/>
<app-all-laboratorio/>
<app-footer-persona/>
